import { DiseaseGroupResponseDto, DiseaseResponseDto } from '@app/api';
import { linkedDiseaseBanners } from './link-diseases-with-banner';
import { ComponentType } from 'react';
import { CommonBannerProps } from '../AllTherapists/components/banners/BannerBase';

interface FilterBannerData {
  id: string;
  Component: ComponentType<CommonBannerProps>;
  isAskona?: boolean;
}
/**
 * To connect all-therapist banners with filter ids
 */
export const getFilterBannerIds = (
  diseasesGroups: DiseaseGroupResponseDto[] | undefined,
): FilterBannerData[] => {
  if (!diseasesGroups) return [];

  const flatDiseases = diseasesGroups.reduce(
    (list, item) => [...list, ...item.items],
    [] as DiseaseResponseDto[],
  );

  return flatDiseases
    .map(({ id, name }) => {
      const foundBanner = linkedDiseaseBanners.find((banner) => {
        if (typeof banner.name === 'object') {
          return banner.name.includes(name);
        }

        return name === banner.name;
      });

      if (!foundBanner) {
        return undefined;
      }

      const { Component, isAskona } = foundBanner;

      return {
        id,
        Component,
        isAskona,
      };
    })
    .filter((item) => item !== undefined) as FilterBannerData[];
};
